import React from 'react';

import './styles.scss'

const LoadingIcon = ({ show }) => {
    if (!show) return null;
    return (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>);
};

export default LoadingIcon;